export default __webpack_public_path__ + "static/media/gallery7.9afa7677.jpg";